(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    for (const root of document.querySelectorAll('[data-pdp]')) {
      const bar = root.querySelector('[data-buybar]');
      const barId = root.querySelector('[data-bar-id]');
      const barTitle = root.querySelector('[data-bar-title]');
      const barPrice = root.querySelector('[data-bar-price]');
      const mainPay = root.querySelector('[data-main-pay]');

      root.querySelectorAll('.offer input').forEach((input) => {
        input.addEventListener('change', () => {
          if (barId) {
            barId.value = input.value;
            barId.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (barTitle) barTitle.textContent = input.dataset.title;
          if (barPrice) barPrice.textContent = input.dataset.price;
          const url = new URL(location.href);
          url.searchParams.set('variant', input.value);
          history.replaceState(history.state, '', url);
        });
      });

      if (bar && mainPay && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          bar.hidden = entry.isIntersecting;
        }).observe(mainPay);
      }

      const deadline = root.querySelector('[data-deadline]');
      const days = deadline && deadline.querySelector('[data-days]');
      const end = deadline && deadline.dataset.deadline ? new Date(deadline.dataset.deadline + 'T23:59:59') : null;
      if (end && !isNaN(end)) {
        const left = Math.ceil((end - Date.now()) / 86400000);
        if (left <= 0) {
          deadline.hidden = true;
        } else {
          days.textContent = left === 1 ? deadline.dataset.last : deadline.dataset.template.replace('__N__', left);
          days.hidden = false;
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
